import {observer} from 'mobx-react-lite'
import React from 'react'
import {newsCompanyId} from 'yougile-model'
import {cn} from '@containers/html-utils'
import {globals} from '@extensions/globals-base'
import {TwEditorContainer} from './containers'
import {EmptyDescription} from './empty-description'
import {useTaskDescription} from './task-description-store'

type Props = {
  children: JSX.Element
  editorContainerRef: React.MutableRefObject<HTMLDivElement | undefined>
}

export const EditorContainer = observer((props: Props) => {
  const [state, store] = useTaskDescription()

  const needToShow = store.taskHub?.description || state.edit
  if (!needToShow) {
    return <EmptyDescription />
  }

  const readonly = !state.edit
  const fullscreen = state.fullscreen

  const hub = store.taskHub
  const isNews = hub && hub.companyId === newsCompanyId

  const isDark = globals.theme === 'dark'
  const editorCls = cn(
    isDark && 'dark-theme',
    fullscreen && 'fullscreen',
    !fullscreen && 'non-fullscreen',
    readonly && 'readonly',
    !readonly && 'editable',
    isNews && 'news'
  )

  const editorStyle: React.CSSProperties = {}
  const {children, editorContainerRef} = props

  return (
    <TwEditorContainer
      ref={editorContainerRef}
      $fullscreen={state.fullscreen}
      className={editorCls}
      style={editorStyle}
      onKeyDown={store.onKeyDown}
    >
      {children}
    </TwEditorContainer>
  )
})
